<template>
  <Layout>
    <PageHeader
        :title="'Hedef Yönetimi'"
        :items="breadcrumbArray"
    ></PageHeader>
    <v-app>
      <div class="container-xxl-fluid py-4">
      <v-row>
        <div v-if="!currentComponent" class="row">
        <v-col @click="changeComponent('CurrentTargetResults')" cols="6">
          <v-card class="ma-3" ripple outlined solo hover min-height="220">
            <v-card-title>
              <v-icon color="primary" class="mx-auto" x-large
              >mdi-checkbook</v-icon
              >
            </v-card-title>
            <v-card-text>
              <div class="text-center w-100 font-weight-black">
                Cari Hedef Cirolar
              </div>
            </v-card-text>
            <v-card-actions>
              <div class="text-center w-100">
                Belirlediğiniz cari hedef cirolarını buradan görüntüleyebilirsiniz.
              </div>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col @click="changeComponent('SalesPersonResults')" cols="6">
          <v-card class="ma-3" ripple outlined solo hover min-height="220">
            <v-card-title>  <v-icon color="primary" class="mx-auto" x-large>mdi-account</v-icon> </v-card-title>
            <v-card-text>
              <div class="text-center w-100 font-weight-black">Plasiyer Hedef Ciro</div>
            </v-card-text>
            <v-card-actions>
              <div class="text-center w-100">
                Belirlediğiniz plasiyer hedef cirolarını buradan görüntüleyebilirsiniz.
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
        </div>
        <div v-else>
          <div class="col-lg-12 text-left ms-2 mb-2">
            <v-btn @click="currentComponent = null" small color="primary"><i class="fas fa-arrow-left"></i> HEDEF SEÇİMİNE DÖN</v-btn>
          </div>
        <component :is="currentComponent"></component>
        </div>
      </v-row>
      </div>


    </v-app>
  </Layout>
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import SalesPersonResults from "@/components/management/target/salesperson/Results.vue";
import CurrentTargetResults from "@/components/management/target/current/Results.vue";

export default {
  page: {
    title: "Hedef Yönetimi",
    meta: [{ name: "description", content: "Hedef Yönetimi" }],
  },
  components: {
    SalesPersonResults,
    CurrentTargetResults,
    Layout,
    PageHeader,
    // CurrentTarget,
    // SalespersonTarget,
  },
  data() {
    return {
      currentComponent: null,
      currentPage: 1,
      treeCategories: [],
      treeBrands: [],
      breadcrumbArray: [
        {
          text: "Yönetim",
          active: false,
        },
        {
          text: "Hedef Yönetimi",
          active: true,
        },
      ],

    };
  },
  methods: {
    changeComponent(componentName) {
      this.currentComponent = componentName;
    },
  },
};
</script>